/* This reducer is used for fetching surgery details */

import {
    SET_UNSAVED_CHANGES_POP_UP,
    SET_ROUTE_PATH_FOR_EQUITY_UNSAVED_CHANGES_POP_UP,
} from '../actions';

const initialState = {
    unsavedChangesPopUp: false,
    routePathForEquityUnsavedChangesPopUp: {
        path: '',
        selectOption: '',
    },
};

const commonReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                unsavedChangesPopUp: action.payload,
            };
        case SET_ROUTE_PATH_FOR_EQUITY_UNSAVED_CHANGES_POP_UP:
            return {
                ...state,
                routePathForEquityUnsavedChangesPopUp: action.payload,
            };
        default: {
            return { ...state };
        }
    }
};

export default commonReducer;
